import { RawApplicantWithApplicationData } from 'types';

import { CreditReportSummary } from '../../types/CreditReports';

export function findCreditReportSummary(
  creditReports: CreditReportSummary[],
  applicant: RawApplicantWithApplicationData,
): CreditReportSummary | undefined {
  // The applicant.id may be an ObjectId or a string depending on the source (older
  // applications and/or applications from API integrations).
  const applicantId = applicant.id ? String(applicant.id) : undefined;
  const applicationId = applicant.applicationId ? applicant.applicationId : undefined;

  if (applicantId) {
    // With release of coBorrower some applicants will have an id. Also, applicant ids
    // can repeat across applications, so the application must match too
    return creditReports.find(
      (report) =>
        report?.applicantId &&
        report.applicantId === applicantId &&
        report?.applicationId &&
        report.applicationId === applicationId,
    );
  }

  if (!applicationId) {
    return undefined;
  }

  return creditReports.find((report) => report?.applicationId && report.applicationId === applicationId);
}
